import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import {getAddressBook} from '../actions/addressBook';
import {filterPhoneNumber} from '../utils/utils';
import { toast } from 'react-toastify';
import {doCall} from '../actions/call';
import {connect} from 'react-redux';
import Loader from './Components/Loader';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
const ESCAPE_KEY = 27;

class HeaderSearch extends Component {
	constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      loading: false,
      searchString: '',
      filteredContacts: []
    };
  }

	componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
	}

  componentWillReceiveProps(nextProps) {
    if(nextProps.addressBook.length !== this.props.addressBook){
      this.getSearchResults(nextProps.addressBook);
    }
  }

  componentWillUnmount() {
	    document.removeEventListener("keydown", this.handleKeyDown);
	}
	/**
	 * gets filtered contacts
	 * @param  {array} addressBook
	 */
  getSearchResults = (addressBook) => {
    if (this.state.searchString.length > 0){
      const filteredContacts = addressBook.filter(item => item.name.toLowerCase().includes(this.state.searchString.toLowerCase()));
      this.setState({
        filteredContacts
      });
    }
  }
	// makes phone call
  handleCall = (e) => {
		const payload = {
			phoneNumber: e.target.id
		};
		this.props.doCall(payload);
  }
	// checks for escape key press and closes contacts popover
	handleKeyDown = (event) => {
    switch( event.keyCode ) {
        case ESCAPE_KEY:
            this.handleClickOutside();
            break;
        default:
            break;
    }
	}
	// handles search when key change is triggered.
  handleSearch = (e) => {
    const searchString = e.target.value;
		this.setState({
			searchString
		}, () => {
    if(searchString.length > 0){
        if(this.props.addressBook.length>0){
          this.setState({
            loading: false,
            isShow: true,
            searchString,
          }, () => {
            this.getSearchResults(this.props.addressBook);
          });
        }else{
          if(!this.state.loading){
            this.setState({
              isShow: true,
              loading: true
            }, () => {
              // set this to true for saving data to reducer
              this.props.getAddressBook(true, (addressBookItems) => {
                this.setState({
                  loading: false
                });
                this.getSearchResults(addressBookItems);
              });
            });
          }
        }
    }else{
      this.setState({
        filteredContacts: [],
        isShow: false
      });
    }
		});
  }
	// closes popover when clicked outside
	handleClickOutside = () => {
    if (this.state.isShow) {
			this.setState({
				isShow: !this.state.isShow,
				searchString: ''
			})
		}
  }
	render() {
    const {
      loading,
      isShow,
      filteredContacts,
			searchString
    } = this.state;
		const {
			translations,
			selectedLanguage,
		} = this.props;
		return (
      <div className="navbar-form navbar-right hidden-xs hidden-sm pos-r">
        <div className={`form-group ${isShow ? 'open' : ''}`}>
          <div className="input-with-icon w-full">
            <input
              type="text"
							value={ searchString }
              className={`form-control${this.props.theme} input-smm${this.props.theme} navbar-autocomplete`}
              placeholder={ translations.search[selectedLanguage] }
              onFocus={ this.handleSearch }
              onChange={ this.handleSearch }
            />
            <span className="icon icon-magnifying-glass" />
          </div>
          <ul className="dropdown-menu notification-list" style={{maxHeight: 300, overflow: 'auto', maxWidth: 220}}>
  					{filteredContacts.length > 0 && filteredContacts.map((item) => (
            <li key={ `${item.id}` }>
              <div className="media">
                <div className="media-body">
                  <span>{item.name}<br /></span>
                  {item.phone_list.map(phone => (
                    <span
                      key={phone.phone}
                      className="cursor"
                      id={phone.phone}
                      onClick={ this.handleCall }
                    >
                      {phone.phone}<br />
                    </span>
                  ))}
  								<div className="small text-muted">{item.company}</div>
                </div>
              </div>
            </li>
  					))}
  					{(filteredContacts.length === 0 && !loading) &&
  						<li className={`notification-footer${this.props.theme}`}>
  	            <a className="text-center" data-toggle="modal" data-target="#notificationsModal">{translations.noContactFound[selectedLanguage]}</a>
  	          </li>
  					}
            {loading &&
  						<li className={`notification-footer${this.props.theme}`}>
  	            <a className="text-center" data-toggle="modal" data-target="#notificationsModal"><Loader width="20px" height="20px" /></a>
  	          </li>
  					}
          </ul>
        </div>
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				agentInfo: state.agentInfo,
				addressBook: state.addressBook,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        theme: state.common.theme,
    };
}

const mapDispatchToProps = {
	getAddressBook,
	doCall
}

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(HeaderSearch));



// WEBPACK FOOTER //
// ./src/agent/HeaderSearch.js